import { Result } from 'antd'
import React from 'react'
import { useHistory } from 'react-router'

import { useIsFeatureToggleOn } from '@/components/feature-toggle/feature-toggle.hooks'
import { useGetViewerQuery } from '@/generated/graphql'
import { routes } from '@/routes'
import { getIsAtAnniversaryDateRange } from './anniversary-card.util'

export const AnniversaryCardRedirect: React.FC = () => {
  const history = useHistory()
  const { data } = useGetViewerQuery({
    variables: {
      withHireDate: true,
    },
  })
  const isFeatureToggleOn = useIsFeatureToggleOn('anniversaryCard')

  if (!isFeatureToggleOn) {
    return null
  }

  if (data && data.viewer.hireDate) {
    const isAnniversaryWithIn7Days = getIsAtAnniversaryDateRange(data.viewer.hireDate)
    if (isAnniversaryWithIn7Days) {
      history.push(routes.section.updates())
    }
  } else {
    return null
  }

  return <Result status='warning' title='超过 7 天未领取，贺卡已失效' />
}
